var lib_core                = require("lib-core");
var MoveableObject3dModel = require("./abstractMoveable3dObjectModel.js");
// Abstract Model class for selectable 3d objects to inherit from

var Handle3dModel = function (editorModel, handleId) {
    MoveableObject3dModel.call(this);

    this.editorModel = editorModel;

    this.isHandle = true;
    this.handleId = handleId;

    this.subjects = this.set("subjects", false);

    this.editorModel.registerHandle(this);

    this.multipleSubjects = true;
};

lib_core.inherit(Handle3dModel, MoveableObject3dModel);
Handle3dModel.$class = "Handle3dModel";

Handle3dModel.prototype.addSubject = function(selectableModel){
    if(this.multipleSubjects == false){
        this.clearSubjects();    
    }
    this.subjects.add(selectableModel);
}

Handle3dModel.prototype.removeSubject = function(selectableModel){
    this.subjects.remove(selectableModel);
}

Handle3dModel.prototype.clearSubjects = function(){
    this.subjects.removeAll();
}

Handle3dModel.prototype.createMovementPlane = function(ray, point){}

Handle3dModel.prototype.setContactPosition = function(position){}

Handle3dModel.prototype.setMousePosition = function(position){}

Handle3dModel.prototype.released = function(){}

module.exports = Handle3dModel;
